function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.links},[_c('ul',_vm._l((_vm.links),function(ref){
var label = ref.label;
var rest = objectWithoutProperties( ref, ["label"] );
var link = rest;
return _c('li',[_c('Link',_vm._b({},'Link',link,false),[_vm._v(" "+_vm._s(label)+" ")])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }